import React, {lazy, useEffect, useState} from 'react';
import {Outlet} from 'react-router-dom'
import styled from 'styled-components'
import {Colors} from '@arboxappv4/shared/src/styles/Colors'
import {useDispatch, useSelector} from "react-redux";
import useSiteQueryParams from "../../helpers/hooks/useSiteQueryParams";
import {Spin} from "antd";
import useScreenSize from "../../helpers/hooks/useScreenSize";
import {LOADING_PAGE, LOADING_PAYMENT, SITE_REFERER} from "@arboxappv4/shared/src/constants/constants";
import {isRTL} from "../../helpers/i18n";
import useLang from "../../helpers/hooks/useLang";
import useCustomMessage from "../../helpers/hooks/useCustomMessage";
import Header from "./Header";
import {getUserInfo} from "@arboxappv4/shared/src/redux/userSlice";
import useKiosk from "../../helpers/hooks/useKiosk";
import {t} from "i18next";
import {stepOptions} from "../../flowManager/StepOptions";
import usePixel from "../../helpers/hooks/UsePixel";

const ModalManager = lazy(() => import(/* webpackChunkName: "ModalManager" */'../popups/ModalManager'));
const Footer = lazy(() => import(/* webpackChunkName: "Footer" */'./Footer'));

const HomeContainer = (props) => {
    const { } = props;
    const referrer = useSelector(state => state.site.referrer)
    const loadingType = useSelector(state => state.site.loadingType)
    const authData = useSelector(state => state.auth.data)
    const currStep = useSelector(state => state.stepper.currStep)
    const [showLoader, setShowLoader] = useState(false);
    const [isFlex, setIsFlex] = useState(true);

    const {isMobile} = useScreenSize();
    const {ready} = useLang()
    useSiteQueryParams({langReady: ready})
    const customMessageContextHolder = useCustomMessage()
    const dispatch = useDispatch()
    useKiosk()
    usePixel()

    const isSite = referrer === SITE_REFERER
    const width = isSite && !isMobile ? '70%' : '100%'

    useEffect(() => {
        setShowLoader([LOADING_PAGE, LOADING_PAYMENT].includes(loadingType))
    }, [loadingType]);

    useEffect(() => {
        if(authData) { // if the login was successful
            dispatch(getUserInfo())
        }
    }, [authData]);


    if(!ready) return null

    return (
        <Spin spinning={!ready || showLoader} tip={loadingType === LOADING_PAYMENT ? t('payment-loader-label') : null}>
            <Wrapper direction={isRTL() ? 'rtl' : 'ltr'} className={'site-wrapper'}>
                {customMessageContextHolder}
                <ModalManager/>
                <HeaderDiv isMobile={isMobile} isPlugin={!isSite}>
                    <Header width={width}/>
                </HeaderDiv>
                <Content isFlex={isFlex} isMobile={isMobile} isPlugin={!isSite}>
                    <Outlet context={[width]}/>
                </Content>
                <FooterDiv isPlugin={!isSite} isMobile={isMobile}>
                    {!(isMobile && currStep === stepOptions.PAYMENT) && <Footer width={width} showOnlyPoweredBy={isMobile}/>}
                </FooterDiv>
            </Wrapper>
        </Spin>
    );
};

export default HomeContainer;

const Wrapper = styled.div`
    background: ${Colors.veryLightGrey}; 
    display: flex;
    height: 100%;
    flex-direction: column;
    direction: ${({direction}) => direction}
`;

const HeaderDiv = styled.div`
    background: ${Colors.white}; 
    height: ${({isMobile}) => isMobile ? 40 : 60}px;
    justify-content: center;
    display: flex;
    padding: 5px ${({isPlugin}) => isPlugin ? '15px' : 0};
    box-shadow: 0px 3px 10px rgba(33, 33, 33, 0.05);
    position: relative;
`;

const FooterDiv = styled.div`
    background: ${({isPlugin, isMobile}) => isPlugin || isMobile ? Colors.siteBg : Colors.white}; 
    height: ${({isMobile}) => isMobile ? '25px' : '70px'};
    display: flex;
    justify-content: center;
    padding: 0 ${({isPlugin, isMobile}) => isPlugin || isMobile ? '15px' : 0};
`;

const Content = styled.div`
    display: flex;
    height: calc(100% - ${({isMobile}) => isMobile ? '65px' : '130px'});
    overflow-y: hidden;
    flex-direction: column;
    background-color: ${Colors.siteBg};
    align-items: center;
    padding: ${({isPlugin, isMobile}) => isPlugin && !isMobile ? '0 15px' : 0};
`;